import axios from 'axios'
import Sales from './sales'

function createPendingRedirectPromise() {
  return new Promise(() => {})
}

function extractSalesToken(payload) {
  if (!payload || typeof payload !== 'object') {
    return undefined
  }

  if (payload.salesToken) {
    return payload.salesToken
  }

  if (payload.order && payload.order.salesToken) {
    return payload.order.salesToken
  }

  if (payload.salesOrder && payload.salesOrder.salesToken) {
    return payload.salesOrder.salesToken
  }

  return undefined
}

function extractStatusCode(payload) {
  if (!payload || typeof payload !== 'object') {
    return undefined
  }

  const statusCandidates = [
    payload.status,
    payload.order && payload.order.status,
    payload.salesOrder && payload.salesOrder.status
  ]

  for (const status of statusCandidates) {
    if (typeof status === 'number') {
      return status
    }

    if (status && typeof status === 'object' && typeof status.code === 'number') {
      return status.code
    }
  }

  return undefined
}

function shouldRedirectToCheckout(payload, salesToken) {
  if (!salesToken) {
    return false
  }

  const statusCode = extractStatusCode(payload)
  return statusCode === undefined || statusCode === 0
}

function normalizeReprocessRequest(orderRequest) {
  if (!orderRequest || typeof orderRequest !== 'object') {
    return orderRequest
  }

  const payload = { ...orderRequest }

  if (payload.salesOrderId === undefined && payload.orderId !== undefined) {
    payload.salesOrderId = payload.orderId
  }

  if (payload.orderId === undefined && payload.salesOrderId !== undefined) {
    payload.orderId = payload.salesOrderId
  }

  return payload
}


class Financial {

  /**
   * Reprocessa pedido.
   *
   * @returns {Promise} .
   */
  reprocessPayout(orderRequest) {
    const payload = normalizeReprocessRequest(orderRequest)
    return axios.post('/v2/financial/reprocessPayout', payload).then(res => {
      const salesToken = extractSalesToken(res.data)
      if (shouldRedirectToCheckout(res.data, salesToken) && Sales.redirectToCheckout(salesToken)) {
        return createPendingRedirectPromise();
      }

      if (res.data.url) {
        const redirectUrl = res.data.url.substring(1, res.data.url.length - 1);
        window.location.assign(redirectUrl);
        return createPendingRedirectPromise();
      }
      return res.data;
    });

  }
  async getNovasTaxas() {
    return await axios.get('/v2/financial/getPlansTaxes')
  }
  async getMeiosDePagamentoAdesao(planId) {
    return await axios.get(`/v2/paymentMethodsByPlan/${planId}`)
  }
  async getPaymentMethodUnauthorized(taxIdNumber) {
    return await axios.get(`/v2/payment-method-unauthorized/getPaymentMethodUnauthorized/${taxIdNumber}`)
  }

}

const instance = new Financial();
export default instance;



// WEBPACK FOOTER //
// ./src/services/financial.js